import $ from "jquery";

Drupal.behaviors.slider = {
  attach: function(context, settings) {
    if (window.document === context) {
      let init = true;

      if (settings.path.currentQuery && settings.path.currentQuery.min_price_value && (init == true)) {
        $("#priceslider").attr('data-initial-start', settings.path.currentQuery.min_price_value / 1.2);
        init = false;
      }

      $('#priceslider').on('changed.zf.slider', function(){
        const value = $("#pricesliderhandle").attr('aria-valuenow');
        if (value > 0) {
          $("#edit-min-price-value").val(value * 1.2);
        }
      });
    }
  }
};
